import React from 'react';
import Card from './Card.jsx';
import { useTranslation } from '../i18n/index.jsx';
import './PlayerHand.css';

const PlayerHand = ({
  cards,
  onCardSelect,
  onCardPlay,
  selectedCard,
  isPlayerTurn,
  currentSum = 0
}) => {
  const { t } = useTranslation();

  const handleCardClick = (card) => {
    if (!isPlayerTurn) return;
    onCardPlay(card);
  };

  return (
    <div className="player-hand">
      <div className="cards-row">
        {cards.map((card, index) => (
          <Card
            key={card.id}
            card={card}
            isSelected={selectedCard?.id === card.id}
            isPlayable={isPlayerTurn}
            onClick={() => handleCardClick(card)}
            currentSum={currentSum}
          />
        ))}
      </div>
      {isPlayerTurn && (
        <span className="hand-hint">{t('tapToPlay')}</span>
      )}
    </div>
  );
};

export default PlayerHand;
